import { render, staticRenderFns } from "./LiveBroadcast.vue?vue&type=template&id=9aad7964&"
import script from "./LiveBroadcast.vue?vue&type=script&lang=js&"
export * from "./LiveBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./LiveBroadcast.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports